import * as React from 'react'
import styles from './CellSelectionIndicator.module.scss'
import cx from 'classnames'
import { Map2D } from 'common/Prose/utils/table/Map2D'

export type CellSelectionIndicatorProps = {
  selectedCells: Array<[number, number]>
}

export const CellSelectionIndicator: React.FC<React.PropsWithChildren<CellSelectionIndicatorProps>> = (props) => {
  const { selectedCells } = props
  const cellPositionMap = new Map2D<boolean>()
  selectedCells.forEach(([y, x]) => {
    cellPositionMap.set(x, y, true)
  })

  const isLeftOpen = (x: number, y: number) => {
    return cellPositionMap.get(x - 1, y) ?? false
  }
  const isRightOpen = (x: number, y: number) => {
    return cellPositionMap.get(x + 1, y) ?? false
  }
  const isTopOpen = (x: number, y: number) => {
    return cellPositionMap.get(x, y - 1) ?? false
  }
  const isBottomOpen = (x: number, y: number) => {
    return cellPositionMap.get(x, y + 1) ?? false
  }

  return (
    <>
      {selectedCells.map(([cellY, cellX], idx) => {
        return (
          <div
            key={`selected-cell-${cellX}-${cellY}`}
            className={cx(styles.CellSelectionIndicator, {
              [styles.openLeft]: isLeftOpen(cellX, cellY),
              [styles.openRight]: isRightOpen(cellX, cellY),
              [styles.openBottom]: isBottomOpen(cellX, cellY),
              [styles.openTop]: isTopOpen(cellX, cellY),
            })}
            style={{
              gridRow: `${(cellY + 1) * 2}/${(cellY + 1) * 2 + 3}`,
              gridColumn: `${(cellX + 1) * 2}/${(cellX + 1) * 2 + 3}`,
            }}
          />
        )
      })}
    </>
  )
}
